import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useI18n } from '../i18n/hooks';

const LanguageSwitcher = () => {
  const { i18n } = useI18n();

  return (
    <Select
      value={['nb', 'en'].includes(i18n.language) ? i18n.language : 'nb'}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      size="small"
      sx={{
        color: 'inherit',
        '.MuiSelect-select': {
          py: 0.5,
          color: 'inherit'
        },
        '.MuiOutlinedInput-notchedOutline': {
          border: 'none'
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: 'none'
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none'
        }
      }}
    >
      {/* Karrierehuset tenant offers Norwegian + English only. Translations
          for other languages still exist in the i18n files; re-add MenuItems
          here to expose them. */}
      <MenuItem value="nb">Norsk</MenuItem>
      <MenuItem value="en">English</MenuItem>
    </Select>
  );
};

export default LanguageSwitcher;